import { useLogto, type IdTokenClaims } from "@logto/react";
import { useEffect, useState } from "react"

export const useUserClaims = () => {
  const [userClaims, setClaims] = useState<IdTokenClaims>();
  const { isAuthenticated, getIdTokenClaims } = useLogto();
  useEffect(() => {
    if (!isAuthenticated) return;
    getIdTokenClaims().then(claims => {
      setClaims(claims);
    });
  }, [isAuthenticated]);
  return [userClaims];
}